import { fallbackChain } from '../i18n/locales'
import type { SiteNoticeMessages } from '../types/siteNotice'

/** Resolve banner copy for the active UI language via locale fallback chain. */
export function resolveSiteNoticeMessage(
  messages: SiteNoticeMessages,
  language: string
): string {
  for (const locale of fallbackChain(language)) {
    const text = messages[locale]?.trim()
    if (text) return text
  }
  return ''
}
